export const MockWalletConfig: TWalletConfig = {
    advance_payment_status: false
}